import React from "react";
import { IconButton } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ChatIcon from "@material-ui/icons/Chat";
import PlayerBadge from "../ui/PlayerBadge";

const MobileGameHeader = ({
  roundNumber,
  maxRounds = 10,
  currentPhase,
  currentTurn,
  name,
  playerCash,
  playerNetWorths = {},
  playerEmojis = {},
  playerColors = {},
  actionsRemaining = {},
  maxActionsPerTurn = 3,
  maxActionsThisTurn = {},
  myTurn,
  onMenuOpen,
  onChatOpen,
  turnTimeRemaining,
  turnTimerPlayer,
  turnTimerTotal,
}) => {
  const phases = [
    { key: 'stock_options', label: '📊', fullLabel: 'Stock Options' },
    { key: 'events', label: '📰', fullLabel: 'Events' },
    { key: 'trading', label: '💼', fullLabel: 'Trading' },
    { key: 'end_of_round', label: '🎲', fullLabel: 'End of Round' }
  ];

  const currentPhaseData = phases.find(p => p.key === currentPhase);
  const playerEmoji = playerEmojis[currentTurn] || '👤';
  const playerColor = playerColors[currentTurn] || '#666666';
  const isMyTurn = myTurn;
  const actions = actionsRemaining[name] || 0;
  const maxForTurn = maxActionsThisTurn[name] ?? maxActionsPerTurn;

  // Format time as MM:SS
  const formatTime = (seconds) => {
    if (seconds === null || seconds === undefined) return '--:--';
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };
  
  // Determine timer color based on remaining time
  const getTimerColor = () => {
    if (!turnTimeRemaining || !turnTimerTotal) return '#4CAF50';
    const percentage = (turnTimeRemaining / turnTimerTotal) * 100;
    if (percentage <= 20) return '#f44336'; // Red
    if (percentage <= 40) return '#ff9800'; // Orange
    return '#4CAF50'; // Green
  };

  return (
    <div className="game-header-mobile" data-tutorial="mobile-header">
      {/* Row 1: Menu, Logo, Round/Phase (stacked), Chat */}
      <div className="mobile-header-row-1">
        <IconButton 
          onClick={onMenuOpen}
          className="mobile-menu-button"
          size="small"
          data-tutorial="mobile-menu"
        >
          <MenuIcon />
        </IconButton>

        {/* Pump N Dump Logo */}
        <div className="mobile-header-logo">
          <h1 className="mobile-logo-text">Pump N Dump</h1>
        </div>

        {/* Timer and Round info side by side */}
        <div className="mobile-header-timer-round-container">
          {/* Timer - Left side */}
          {turnTimeRemaining !== null && turnTimeRemaining !== undefined && (
            <div 
              className="mobile-header-timer-container"
              style={{
                color: getTimerColor(),
                border: `1px solid ${getTimerColor()}`,
              }}
            >
              <span className="mobile-header-timer-icon">⏱️</span>
              {formatTime(turnTimeRemaining)}
            </div>
          )}
          <div className={`mobile-current-player ${isMyTurn ? 'my-turn' : ''}`}>
            {/* Play icon indicator */}
            <span className="mobile-current-player-icon">▶</span>
            {/* Player badge */}
            <PlayerBadge
              playerName={currentTurn}
              playerColor={playerColor}
              playerEmoji={playerEmoji}
              size="medium"
              className="mobile-current-player-badge"
              style={{ fontWeight: isMyTurn ? 'bold' : 'normal', color: isMyTurn ? 'var(--color-primary)' : 'inherit' }}
            />
          </div>
          {/* Round and Phase stacked - Right side */}
        <div className="mobile-header-round-phase" data-tutorial="round-tracker">
          <div className="mobile-round-badge">
            R {roundNumber}/{maxRounds}
          </div>
          <div className={`mobile-phase-badge ${currentPhase ? 'active' : ''}`} data-tutorial="game-phases">
            {currentPhaseData?.label} {currentPhaseData?.fullLabel}
            </div>
          </div>
        </div>

        <IconButton 
          onClick={onChatOpen}
          className="mobile-chat-button"
          size="small"
        >
          <ChatIcon />
        </IconButton>
      </div>

      {/* Row 2: Current Player, Your Player, Stats */}
      <div className="mobile-header-row-2">
        {/* Current player turn */}

        {/* Your player badge */}
        <div className="mobile-your-player">
          <PlayerBadge
            playerName={name}
            playerColor={playerColors[name]}
            playerEmoji={playerEmojis[name]}
            size="medium"
            className="mobile-your-player-badge"
          />
        </div>

        <div className="mobile-player-stats">
          <div className="mobile-stat-item mobile-stat-item-cash">
            <span>💰</span>
            <span className="mobile-stat-value mobile-stat-value-cash">
              ${(playerCash[name] || 0).toLocaleString()}
            </span>
          </div>
          <div className="mobile-stat-item mobile-stat-item-networth">
            <span>💎</span>
            <span className="mobile-stat-value mobile-stat-value-networth">
              ${(playerNetWorths[name] || 0).toLocaleString()}
            </span>
          </div>
          <div className={`mobile-stat-item mobile-actions-stat ${isMyTurn && actions > 0 ? 'active' : ''}`}>
            <span>⚡</span>
            <span className="mobile-stat-value">
              {actions}/{maxForTurn}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileGameHeader;

